/* eslint-disable react-hooks/exhaustive-deps */
import { CheckCircleIcon, MapPinIcon } from '@heroicons/react/24/solid'
import { MailOutlineOutlined, Person, Smartphone } from '@mui/icons-material'
import { Button, InputAdornment, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useArrangeMeetingMutation } from '../../helpers/SendEmailApi'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'


const CustomComponent = ({ message }) => {
  return (
    <div className='h-full'>
      <div className='absolute top-0  left-0 right-0 z-[9999]'>
        <div className='flex justify-center'>
          <CheckCircleIcon className='h-[55px] text-green-500 z-50 relative' />
        </div>
      </div>
      <div className='pt-[50px]'>
        <h1 className='text-center'>
          {message}
        </h1>
      </div>
    </div>
  )
}

const Summary = ({ selectedTime, setselectedTime, startTime, endTime, refetch }) => {

  const [name, setname] = useState('')
  const [email, setemail] = useState('')
  const [phone, setphone] = useState('')

  const navigate = useNavigate()

  const preventMinus = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  };

  const [func, res] = useArrangeMeetingMutation()


  const handleSubmit = (e) => {
    e.preventDefault()
    func({ name, email, startTime, endTime, phone })
  }

  useEffect(() => {

    if (res.status === 'fulfilled') {

      setname('')
      setemail('')
      navigate('/')
      refetch()
      toast(<CustomComponent message={'Response Submitted Successfully!'} />, {
        position: "top-center",
        autoClose: 1100,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        toastClassName: "rounded-lg",
        className: 'text-[18px] md:w-[400px] h-full mt-4 mx-4 rounded-md relative z-50',
        style: { borderRadius: '15px' },
      });

      setTimeout(() => {

        toast(<CustomComponent message={`Your Meeting has been arranged successfully on ${selectedTime}`} />, {
          position: "top-center",
          autoClose: 1450,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          toastClassName: "rounded-lg",
          className: 'text-[18px] md:w-[400px] h-full mx-4 mt-4 rounded-md relative z-50',
          style: { borderRadius: '15px' },
        });

      }, 4000);
    }

  }, [res])

  return (
    <div>

      <div className='relative z-50'>
        <ToastContainer />
      </div>

      <div className='bg-white hover:scale-105 duration-700 rounded-lg p-3 shadow-md w-full md:w-[600px] mx-auto'>
        <h1 className='font-bold text-sm md:text-lg'>
          Your <span className='text-red-500'>information</span>
        </h1>
        <h6 className='font-bold text-[14px] md:text-[16px] mt-2 text-gray-500'>
          {selectedTime}
        </h6>
        <div className='flex gap-1 items-center mt-1'>
          <MapPinIcon className='text-gray-500 w-3 ' />
          <h2 className='text-[13px] font-bold'>
            Google Meet
          </h2>
        </div>

        <form onSubmit={(e) => handleSubmit(e)} className='p-2 mt-3 space-y-4'>
          <TextField
            placeholder='Enter Your Name'
            id='Email'
            required
            value={name}
            fullWidth
            onChange={(e) => setname(e.target.value)}
            InputProps={{
              disableUnderline: true,
              style: {
                fontSize: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Person sx={{ fontSize: '25px' }} />
                </InputAdornment>
              )
            }}
            sx={{

              '& .MuiInputBase-root': {
                padding: '7px 10px',
                borderRadius: '10px',
                transition: 'all 0.4s ease-in-out',
                backgroundColor: '#f2f7fb',
              },
              '& .Mui-focused': {
                backgroundColor: 'black !important',
                color: 'white',
                '& .MuiSvgIcon-root': {
                  color: 'white'
                },
                '& ::placeholder': {
                  color: 'white',
                  opacity: '0.7'
                }
              },

            }}
            variant="standard"
          />
          <TextField
            placeholder='Enter Your WhatsApp'
            id='phone'
            onKeyDown={preventMinus}
            type={'number'}
            required
            value={phone}
            fullWidth
            onChange={(e) => setphone(e.target.value)}
            InputProps={{
              disableUnderline: true,
              inputMode: 'numeric',
              pattern: '\\d*',
              style: {
                fontSize: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Smartphone sx={{ fontSize: '25px' }} />
                </InputAdornment>
              )
            }}
            sx={{
              '& input[type=number]': {
                '-moz-appearance': 'textfield', /* Firefox */
                '-webkit-appearance': 'textfield', /* Safari and Chrome */
                'appearance': 'textfield', /* Hide spinner arrows for IE, Edge, and Opera */
                'paddingRight': '0.5rem', /* Add some right padding to prevent text from overlapping arrows */
                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                  '-webkit-appearance': 'none',
                  'margin': 0
                }
              },
              '& .MuiInputBase-root': {
                padding: '7px 10px',
                borderRadius: '10px',
                transition: 'all 0.4s ease-in-out',
                backgroundColor: '#f2f7fb',
              },
              '& .Mui-focused': {
                backgroundColor: 'black !important',
                color: 'white',
                '& .MuiSvgIcon-root': {
                  color: 'white'
                },
                '& ::placeholder': {
                  color: 'white',
                  opacity: '0.7'
                }
              },

            }}
            variant="standard"
          />
          <TextField
            placeholder='Enter Your Email'
            id='Email'
            type={'email'}
            required
            fullWidth
            value={email}
            onChange={(e) => setemail(e.target.value)}
            InputProps={{
              disableUnderline: true,
              style: {
                fontSize: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <MailOutlineOutlined sx={{ fontSize: '25px' }} />
                </InputAdornment>
              )
            }}
            sx={{

              '& .MuiInputBase-root': {
                padding: '7px 10px',
                borderRadius: '10px',
                transition: 'all 0.4s ease-in-out',
                backgroundColor: '#f2f7fb',
              },
              '& .Mui-focused': {
                backgroundColor: 'black !important',
                color: 'white',
                '& .MuiSvgIcon-root': {
                  color: 'white'
                },
                '& ::placeholder': {
                  color: 'white',
                  opacity: '0.7'
                }
              },

            }}
            variant="standard"
          />

          <div className='flex justify-between pt-3'>
            <button
              onClick={() => setselectedTime('')}
              className="rounded-2xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[12px] md:text-[15px] border-black text-black ">
              <span className="absolute w-64 h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 bg-black top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
              <span className="relative text-black group-hover:text-white transition duration-700 ease">Cancel</span>
            </button>
            <Button
              variant='contained' color='error'
              className='blob-btn'
              size='large'
              type='submit'
              disabled={res.isLoading && true}
              sx={{
                borderRadius: '30px',
                fontSize: { xs: '12px', sm: '15px' },
                backgroundColor: '#ff9800 !important',
                textTransform: 'none',
                transition: 'all 0.7s ease-in-out',
                '&:hover': {
                  boxShadow: '0 0 20px rgba(0,0,0,0.3)',
                  transform: 'scale(1.1)'
                }
              }}
            >
              Confirm
              <span className="blob-btn__inner">
                <span className="blob-btn__blobs">
                  <span className="blob-btn__blob"></span>
                  <span className="blob-btn__blob"></span>
                  <span className="blob-btn__blob"></span>
                  <span className="blob-btn__blob"></span>
                </span>
              </span>

            </Button>
          </div>

        </form>

      </div>
    </div>
  )
}

export default Summary